import { motion } from "motion/react";
import Check from "../ui/Check/Check";
import StarThankYou from "../ui/StarThankYou/StarThankYou";

const SpinningStar = () => (
  <>
    <motion.div
      animate={{ rotate: "360deg" }}
      initial={{ rotate: "0deg" }}
      transition={{ duration: 12, repeat: Infinity }}
    >
      <StarThankYou className="mb-2 fill-bright-future-base" />
    </motion.div>
    <Check className="absolute top-[35%] left-1/2 h-7 w-8 -translate-x-1/2 -translate-y-1/2 transform stroke-2 stroke-white" />
  </>
);

export default SpinningStar;
